module.exports = __webpack_public_path__ + "static/media/user.ee787694.svg";